import React from "react";
import "./Shimmer.css";
const Shimmer = () => {
  return (
    <div className="grid__5--cal">
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
      <div className="shimmer_card"></div>
    </div>
  );
};

export default Shimmer;
